import React from 'react';
import styles from './BetLines.module.scss';
import HomeTeamName from './BetLine/HomeTeamName/HomeTeamName';
import OddBadge from './BetLine/OddBadge/OddBadge';
import DeleteBetLineButton from './BetLine/DeleteButton/DeleteButton';
import MarketName from './BetLine/MarketName/MarketName';
import LiveBadge from '../../shared/LiveBadge/LiveBadge';
import Mbn from './BetLine/Mbn/Mbn';
import ProgramCode from './BetLine/ProgramCode/ProgramCode';
import EventName from './BetLine/EventName/EventName';
import ClosedBetLine from './BetLine/ClosedBetLine/ClosedBetLine';
import BetStake from './BetLine/BetStake/BetStake';
import { EVENT_TYPE_ENUM } from '../../../constants/enums';

const SingleBetLine = ({ bet }) => {
    return (
        <div className={styles.bet}>
            <ClosedBetLine bet={bet} />
            <div className='flex'>
                <HomeTeamName name={bet.outcomeName} />
                <OddBadge bet={bet} />
                <DeleteBetLineButton bet={bet} />
            </div>
            <div className={'m-b-2'}>
                <MarketName name={bet.marketName} />
                <LiveBadge isLive={bet.isLive} />
            </div>
            <div className={'m-b-3'}>
                <Mbn mbn={bet.mbn} />
                {bet.eventType !== EVENT_TYPE_ENUM.outright && (
                    <ProgramCode programCode={bet.programCode} />
                )}
                <EventName teams={bet.teams} eventName={bet.eventName} />
            </div>
            <BetStake bet={bet} />
        </div>
    );
};

export default SingleBetLine;
